<!-- 抵用券 -->
<template>
    <div class="voucher">
        <!-- <lazy-load-list :getData="initData" :description="'暂无优惠券'" :query="query">
            <template v-slot="slotData"> -->
        <div v-if="dataList.length > 0" class="voucher-list">
            <van-radio-group v-model="result" ref="invoiceCheckbox" @change="invoiceitemChange">
                <div class="voucher-list-item" v-for="(item, index) in dataList" :key="index">
                    <div class="top">
                        <div class="voucher-list-item-num">
                            <div>
                                <span class="flag">￥</span>
                                <span class="num">{{  Number(item.amount)  }}</span>
                            </div>
                            <div  class="use-limit" v-if="item.useLimit">满{{  Number(item.useLimit)  }}元可用</div>
                        </div>

                        <span class="line"></span>
                        <span class="voucher-list-item-content">
                            <div class="title">
                                {{  item.couponName  }}

                            </div>

                            <div class="content">{{  toStr(item)  }}</div>

                        </span>
                        <van-radio @click="radioClick(item)" checked-color="#009AF3" v-if="flag"
                            :name="item.couponDetailId"></van-radio>
                    </div>

                    <div v-if="item.beginTime && item.endTime" class="bottom">{{  item.beginTime  }} ~ {{  item.endTime  }}
                    </div>
                    <div v-else class="bottom">暂无使用期限</div>
                </div>
            </van-radio-group>
        </div>
        <van-empty class="empty-position" :description="description" v-if="dataList.length == 0" />
        <div class="parkingPay-comfirm-btn">
            <van-button @click="use" class="comfirm-btn">{{  flag ? "确定使用" : "返回"  }}</van-button>
        </div>
        <!-- </template>
        </lazy-load-list> -->
    </div>
</template>

<script>
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";

import { listMyCoupon, listCanUseCoupon } from "@/api/api";
//用于查找可用的优惠券列表
export default {
    name: "voucher",
    components: { LazyLoadList },

    data() {
        return {
            query: {
                // application: 1
                couponStatus: 1,
            },
            result: "",
            couponMoney: "",
            dataList: [],
            description: "暂无优惠券",
            flag: false, //是否有传值进来
            obj: {},
        };
    },
    beforeRouteLeave(to, from, next) {


        next();
    },

    mounted() {
        // console.log(this.obj);
        this.obj = this.$route.params;
        // console.log(this.obj);
        this.flag = Object.keys(this.obj).length == 0 ? false : true;
        //如果没传值
        if (!this.flag) {
            listMyCoupon(this.query).then((res) => {
                this.dataList = res.data;
            });
        } else {
            let query = {
                couponStatus: 1,
                application: this.obj.application,
                parkCode: this.obj.parkCode,
                needPay: this.obj.needPay
            };
            listCanUseCoupon(query).then((res) => {
                this.dataList = res.data;
                this.result = this.obj.couponDetailId;
                this.couponMoney = this.obj.couponMoney;
                // debugger;
            });
        }
    },

    methods: {
        invoiceitemChange() { },
        //radio点击
        radioClick(item) {
            this.couponMoney = item.amount;
        },
        //给子组件用
        initData() {
            return listMyCoupon(this.query);
        },

        toStr(item) {
            let strArr = item.application.split(",");

            //根据下标获取文字
            let arr = ["", "余额充值", "限路内(道路)停车缴费可用", "预约缴费", "预约超时缴费", "停车预缴", "限路外(停车场)停车缴费可用", "会员升级", "错峰停车", "商家优惠券", "包月"];
            let str = strArr
                .map((item) => {

                    return arr[item];
                })


            // 将限路内(道路)停车缴费可用  2、限路外(停车场)停车缴费可用 6  合并成限停车缴费可用
            let onIndex = strArr.indexOf('2')
            let outIndex = strArr.indexOf('6')
            if (onIndex != -1 && outIndex != -1) {
                str[onIndex] = '限停车缴费可用'
                str.splice(outIndex, 1)
            }


            return str.join("，");
        },

        use() {
            if (this.flag) {
                if (!this.result) {
                    this.$toast("请选择一张优惠券");
                    return;
                } else {
                    this.obj.couponDetailId = this.result;
                    this.obj.couponMoney = this.couponMoney;

                    this.$router.replace({ name: "ParkingPay", query: this.obj });
                }
            } else {
                this.$router.go(-1);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.parkingPay-comfirm-btn {
    position: absolute;
    bottom: 0;
    width: 750px;
    height: 122px;
    margin-top: auto;
    text-align: center;
    background-color: #fff;
    color: #fff;
}

.voucher-list {
    margin-bottom: 150px;

    .voucher-list-item {
        margin: 16px auto 0 auto;
        // margin-top: 16px;
        width: 690px;
        height: 230px;
        background: url("~@/assets/images/mine/voucher.png") no-repeat;
        background-size: 100% 100%;

        .top {
            height: 155px;
            width: 690px;
            display: flex;
            align-items: center;

            .line {
                display: inline-block;
                height: 100px;
                width: 1px;
                border: 1px solid #ffffff33;
            }

            .voucher-list-item-content {
                color: #fff;
                margin-left: 40px;

                .title {
                    font-size: 30px;
                    margin-bottom: 10px;
                }



                .content {
                    width: 400px;
                    margin-top: 10px;
                    // color: #aed1f7;
                    color: #fff;
                }
            }

            .voucher-list-item-num {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                width: 185px;
                height: 155px;
                position: relative;

                .use-limit {
                    font-size: 24px;
                    position: absolute;
                    bottom: 10px;
                }

                // border: 1px red solid;
                .num {
                    font-size: 80px;
                }
            }
        }

        .bottom {
            height: 70px;
            width: 690px;
            line-height: 70px;
            color: #afafaf;
            padding-left: 20px;
        }
    }
}
</style>
